package com.wintermar.inspection.core.data

import com.russhwolf.settings.Settings
import com.wintermar.inspection.EnvConfig
import kotlinx.browser.document

actual fun getToken(settings: Settings, key: String): String? {
    return getCookieValue(EnvConfig.POSEIDON_WINHUB_TOKEN_KEY)
}

actual fun setToken(
    settings: Settings,
    key: String,
    token: String?
) {
    // no-op
}

/**
 * Parses `document.cookie` – a semicolon-separated "name=value" string –
 * and returns the decoded value for [name], or null if the cookie is absent.
 *
 * WHY this works for the parent app's cookie:
 *   Cookies are scoped by **domain**, NOT by port.
 *   - Production : inspection runs on the same domain as the parent,
 *                  so they share cookies automatically.
 *   - Dev        : both run on `localhost` (example different ports: 3001 vs 8080),
 *                  but the browser treats them as the same cookie domain, so
 *                  a cookie set by localhost:3001 is visible here on localhost:8080.
 */
private fun getCookieValue(name: String): String? =
    document.cookie
        .split(";")
        .map { it.trim() }
        .firstOrNull { it.startsWith("$name=") }
        ?.removePrefix("$name=")
